import React from "react";
import { connect } from "react-redux";

/**
 * Enterprise Management Communication options
 *
 **/
class Communication extends React.Component {

  render() {

    return (
      <>
        Communication
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
  };
};
export default connect(mapStateToProps)(Communication);